import { matchPath } from 'react-router';

import routing, {
  EARLY_DOCS_COLLECTION,
  EARLY_DOCS_VERIFICATION,
  POST_SALE_DOCS_COLLECTION,
  VERIFY_YOUR_IDENTITY_ROUTE,
} from 'Utilities/routing';

export const CAR_PRIZE_DRAW_URL = '/car-prize-draw';

const GET_AHEAD_DOCS_COLLECTION = `${routing.vrmPath}/get-ahead/upload-documents/:kind?`;

const EARLY_DOCS_ROUTES = [
  EARLY_DOCS_COLLECTION,
  EARLY_DOCS_VERIFICATION,
  GET_AHEAD_DOCS_COLLECTION,
];

const INCODE_ROUTES = [
  POST_SALE_DOCS_COLLECTION,
  VERIFY_YOUR_IDENTITY_ROUTE,
];

export const CAR_PRIZE_BANNER_EXCLUDED_ROUTES = Object.freeze([
  ...EARLY_DOCS_ROUTES,
  ...INCODE_ROUTES,
]);

export const isCarPrizeBannerExcludedRoute = (pathname: string) =>
  CAR_PRIZE_BANNER_EXCLUDED_ROUTES.some((path) => !!matchPath(pathname, { path }));
